"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;











































































































var _utils = require("@/utils/utils");
var _user = require("@/utils/user");
var _formatter = require("@/utils/formatter"); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { data: function data() {return { tableData: [], // 列表数据
      searchData: { userId: '', mobile: '', email: '', appName: '', appVersion: '', sysType: '', time: [(0, _formatter.simpleFormatter)(new Date() - 3600 * 1000 * 24 * 179), ''], page: 1, // 当前页码
        rows: 10 // 页码条
      }, pageData: { page: 1, rows: 10, total: 0, pages: 1 }, // 表格列
      tableColumns: [{ prop: 'userId', label: '用户ID', isShow: true }, { prop: 'mobile', label: '手机号', isShow: true }, { prop: 'email', label: '邮箱', isShow: true }, { prop: 'appName', label: 'APP名称', isShow: true }, { prop: 'appVersion', label: 'APP版本', isShow: true }, { prop: 'phoneId', label: '终端唯一编码', isShow: true }, { prop: 'mac', label: '终端MAC地址', isShow: true }, { prop: 'sysType', label: '系统类型', formatter: _formatter.sysTypeFormatter, isShow: true }, { prop: 'sysVersion', label: '系统版本', isShow: true }, { prop: 'latitude', label: '经度', isShow: true }, { prop: 'longitude', label: '纬度', isShow: true }, { prop: 'country', label: '国家', isShow: false }, { prop: 'province', label: '省份', isShow: false }, { prop: 'city', label: '市', isShow: false }, { prop: 'district', label: '区县', isShow: false }, { prop: 'address', label: '位置信息', isShow: true }, { prop: 'createTime', label: '创建时间', formatter: _formatter.dateFormatter, isShow: false }, {
        prop: 'updateTime',
        label: '更新时间',
        formatter: _formatter.dateFormatter,
        isShow: true }] };



  },
  mounted: function mounted() {
    var self = this;
    self.init();
  },
  methods: {
    init: function init() {
      var self = this;
      var params = Object.assign({}, self.searchData);
      if (params.time) {
        params.startTime = params.time[0] + ' 00:00:00';
        params.endTime = params.time[1] ? params.time[1] + ' 23:59:59' : '';
      }
      delete params['time'];
      self.getData('/api/userAddress', params, function (res) {
        console.log("res", res);
        self.tableData = res.list;
        self.pageData.page = res.pageNum;
        self.pageData.total = res.total;
      });
    },
    checkPermission: _user.checkPermission,
    resetFun: function resetFun() {// 重置
      this.searchData.userId = '';
      this.searchData.mobile = '';
      this.searchData.email = '';
      this.searchData.appName = '';
      this.searchData.appVersion = '';
      this.searchData.sysType = '';
      this.searchData.time = '';
      this.init();
    },
    searchFun: function searchFun() {// 搜索事件
      this.searchData.page = 1;
      this.init();
    },
    handleSizeChange: function handleSizeChange(val) {// 分页条数
      this.searchData.rows = val;
      this.searchData.page = 1;
      this.init();
    },
    handleCurrentChange: function handleCurrentChange(val) {// 分页页码
      this.searchData.page = val;
      this.init();
    },
    excelFun: function excelFun() {
      var self = this;
      // 校验时间是否填写
      var params = Object.assign({}, self.searchData);
      if (params.time === '') {
        self.$message({
          message: '请选择开始时间',
          type: 'error' });

        return;
      }
      var day_180 = 3600 * 180 * 24 * 1000;
      var start = new Date(params.time[0]);
      var deliverTimeStart = start.getTime();
      var end = params.time[1] ? new Date(params.time[1]) : new Date();
      var deliverTimeEnd = end.getTime();
      if (deliverTimeEnd - deliverTimeStart > day_180) {
        self.$message({
          message: '只能导出小于等于180天的的时间',
          type: 'error' });

        params.endTime = '';
        return;
      }
      params.startTime = params.time[0] + ' 00:00:00';
      params.endTime = params.time[1] ? params.time[1] + ' 23:59:59' : '';
      window.location.href = '/api/userAddress/export?startTime=' +
      params.startTime + '&endTime=' + params.endTime + '&userId=' +
      params.userId + '&email=' + params.email + '&mobile=' +
      params.mobile + '&appName=' + params.appName + '&appVersion =' +
      params.appVersion + '&sysType=' + params.sysType;
    } } };exports.default = _default;